import { Injectable, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginResponse, NO_PERMISSIONS, UserInfo } from '@models/users.model';
import { getStorage } from '@helpers/function.helper';
import { SETTING_KEYS } from '@constants/settings.constant';
import { lastValueFrom, map } from 'rxjs';
import { IResponse } from '@models/common.model';
import { EndPoint } from '@constants/api.constant';
import { NgxPermissionsService } from 'ngx-permissions';
import { environment } from '@environments/environment';
import { toObservable } from '@angular/core/rxjs-interop';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private _userInfo = signal<UserInfo>({} as UserInfo);
  private ignoredHost = [
    'localhost',
    '192.168.31.110',
    '26.61.189.67',
    '172.19.96.1',
    '172.31.144.1',
  ];
  constructor(
    private httpClient: HttpClient,
    private permissions: NgxPermissionsService
  ) {}

  async getUserInfo() {
    const requiredLogin = this.ignoredHost.every(
      x => !location.origin.includes(x)
    );
    if (!requiredLogin && !getStorage(SETTING_KEYS.jwt)) {
      const response = await lastValueFrom(
        this.httpClient.post<IResponse<LoginResponse>>(EndPoint['login'].path, {
          username: environment.user,
          password: environment.password,
        })
      );
      localStorage.setItem(
        SETTING_KEYS.jwt,
        JSON.stringify(response.data.accessToken)
      );
    }
    if (!getStorage(SETTING_KEYS.jwt)) {
      this.permissions.loadPermissions([NO_PERMISSIONS]);
      return NO_PERMISSIONS;
    }
    try {
      const response = await lastValueFrom(
        this.httpClient.get<IResponse<UserInfo>>(EndPoint['userInfo'].path)
      );
      this._userInfo.set(response.data);
      this.permissions.loadPermissions([response.data.role]);
      return response.data.role;
    } catch (error) {
      console.log(error);
      localStorage.clear();
    }
    this.permissions.loadPermissions([NO_PERMISSIONS]);
    return NO_PERMISSIONS;
  }

  get userInfo() {
    return this._userInfo.asReadonly();
  }

  get login$() {
    return toObservable(this.userInfo).pipe(map(x => !!x.id));
  }
}
